import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import ExcelJS from "exceljs";
import Footer from "./Footer";
import Header from "./Header";
import config from "../../config";

const Bulk_order_log_detail_new = () => {
  const [searchParams] = useSearchParams();
  const record_id = searchParams.get("id");

  const [userData, setUserData] = useState({});
  const [state, setState] = useState({ log: [] });
  const [stateRecord, setStateRecord] = useState({
    total_record: 0,
    uploaded_record: 0,
    status: "",
  });
  const [activeTab, setActiveTab] = useState("success");
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    const userDetail = localStorage.getItem("ship_rocket_user");
    if (userDetail) {
      try {
        setUserData(JSON.parse(userDetail));
      } catch (error) {
        console.error("Unable to parse user data:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (userData?.customer_id && record_id) shipment_list();
  }, [userData?.customer_id, record_id]);

  const shipment_list = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        config.apiUrl + "/shipment/view_summary",
        {
          customer_id: userData.customer_id,
          record_id,
          status: null,
        },
        { headers: config.headers }
      );

      const output = Array.isArray(res.data?.output) ? res.data.output : [];
      if (output.length) {
        const summary = output[0];
        setState(summary);
        setStateRecord({
          uploaded_record: Number(summary.uploaded_record) || 0,
          total_record: Number(summary.total_record) || 0,
          status: summary.status || "",
        });
      } else {
        setState({ log: [] });
        setStateRecord({ total_record: 0, uploaded_record: 0, status: "" });
      }
    } catch (error) {
      console.error("Bulk order log detail error:", error);
      setState({ log: [] });
    } finally {
      setLoading(false);
    }
  };

  const summary_record = async () => {
    if (!userData?.customer_id || !record_id) return;
    try {
      const url =
        config.apiUrl +
        "/shipment/view_summary_upload_record?customer_id=" +
        encodeURIComponent(userData.customer_id) +
        "&record_id=" +
        encodeURIComponent(record_id);

      await axios({
        method: "get",
        url,
        headers: config.headers,
        responseType: "text",
        onDownloadProgress: (progressEvent) => {
          try {
            const responseText =
              progressEvent?.event?.target?.responseText || "";
            if (!responseText) return;
            const chunks = responseText.split("Z");
            const latest = chunks[chunks.length - 1]?.trim();
            if (!latest) return;
            const data = JSON.parse(latest);
            setStateRecord({
              uploaded_record: Number(data.uploaded_record) || 0,
              total_record: Number(data.total_record) || 0,
              status: data.status || "",
            });
          } catch (_) {
            // The streaming endpoint can expose an incomplete JSON chunk.
          }
        },
      });
    } catch (error) {
      console.error("Summary upload record error:", error);
    }
  };

  useEffect(() => {
    if (
      stateRecord.total_record > 0 &&
      stateRecord.uploaded_record < stateRecord.total_record
    ) {
      summary_record();
    }
  }, [
    stateRecord.total_record,
    stateRecord.uploaded_record,
    userData?.customer_id,
    record_id,
  ]);

  const logs = Array.isArray(state?.log) ? state.log : [];
  const successlog = useMemo(
    () => logs.filter((item) => Number(item?.status) === 1),
    [logs]
  );
  const failedlog = useMemo(
    () => logs.filter((item) => Number(item?.status) === 2),
    [logs]
  );

  const successcount = successlog.length;
  const failedcount = failedlog.length;
  const totalRecord = Number(stateRecord.total_record) || 0;
  const uploadedRecord = Number(stateRecord.uploaded_record) || 0;
  const pendingCount = Math.max(totalRecord - uploadedRecord, 0);
  const progress =
    totalRecord > 0
      ? Math.min(Math.round((uploadedRecord / totalRecord) * 100), 100)
      : 0;
  const isCompleted = totalRecord > 0 && uploadedRecord >= totalRecord;
  const isRunning = !isCompleted && totalRecord > 0;
  const activeLogs = activeTab === "success" ? successlog : failedlog;

  const shipmentFilter = (status) => {
    setActiveTab(status === 1 ? "success" : "failed");
  };

  const handleRefreshButtonClick = () => shipment_list();

  const generateExcel = async (orderDetails, worksheetName, fileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(worksheetName);
    worksheet.columns = [
      { header: "Order_ID", key: "Order_ID" },
      { header: "Order_Date", key: "Order_Date" },
      { header: "Warehouse_Name", key: "Warehouse_Name" },
      { header: "Receiver_Name", key: "Receiver_Name" },
      { header: "Receiver_Address", key: "Receiver_Address" },
      { header: "Receiver_Pincode", key: "Receiver_Pincode" },
      { header: "Receiver_Email", key: "Receiver_Email" },
      { header: "Receiver_Mobile", key: "Receiver_Mobile" },
      { header: "Return_Name", key: "Return_Name" },
      { header: "Return_Address", key: "Return_Address" },
      { header: "Return_Pincode", key: "Return_Pincode" },
      { header: "Return_Email", key: "Return_Email" },
      { header: "Return_Mobile", key: "Return_Mobile" },
      { header: "Item_Name", key: "Item_Name" },
      { header: "Height", key: "Height" },
      { header: "Width", key: "Width" },
      { header: "Length", key: "Length" },
      { header: "Weight", key: "Weight" },
      { header: "Item_Value", key: "Item_Value" },
      { header: "Item_Quantity", key: "Item_Quantity" },
      { header: "Payment_Mode", key: "Payment_Mode" },
      { header: "COD_Value", key: "COD_Value" },
      { header: "Reason", key: "Reason" },
    ];
    worksheet.addRows(Array.isArray(orderDetails) ? orderDetails : []);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const downloadReport = async () => {
    if (!failedlog.length || downloading) return;
    try {
      setDownloading(true);
      const response = await fetch(
        config.apiUrl + "/shipment/get_order_details",
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify({ failedlog, record_id }),
        }
      );
      if (!response.ok) throw new Error("Failed to download failed report");
      const orderDetails = await response.json();
      await generateExcel(
        orderDetails,
        "Failed Orders",
        "FailedOrdersReport.xlsx"
      );
    } catch (error) {
      console.error("Failed report download error:", error);
    } finally {
      setDownloading(false);
    }
  };

  const successdownloadReport = async () => {
    if (!successlog.length || downloading) return;
    try {
      setDownloading(true);
      const response = await fetch(
        config.apiUrl + "/shipment/get_success_order_details",
        {
          method: "POST",
          headers: config.headers,
          body: JSON.stringify({ successlog, record_id }),
        }
      );
      if (!response.ok) throw new Error("Failed to download success report");
      const orderDetails = await response.json();
      await generateExcel(
        orderDetails,
        "Success Orders",
        "SuccessOrdersReport.xlsx"
      );
    } catch (error) {
      console.error("Success report download error:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div>
      <Header>
        <div className="content">
          <div className="ol-header">
            <div className="ol-hd">
              <a
                type="button"
                className="ol-back"
                // onClick={() => window.history.back()}
                title="Go back"
                href="javascript:window.history.back();"
              >
                <i className="bi bi-arrow-left"></i>
              </a>
              <div>
                <div className="ol-title">Bulk Order Log</div>
                <div className="ol-sub">Log ID #{record_id || "-"}</div>
              </div>
            </div>
          </div>

          <div className="bld-hero">
            <div className="bld-hero-bg"></div>
            <div className="bld-hero-content">
              <div className="bld-hero-icon">
                <i
                  className={`bi ${
                    isRunning ? "bi-arrow-repeat spin" : "bi-check-circle-fill"
                  }`}
                ></i>
              </div>
              <div className="bld-hero-info">
                <div className="bld-hero-title">
                  {loading
                    ? "Loading order status..."
                    : `${uploadedRecord}/${totalRecord} Orders Created`}
                </div>
                <div className="bld-hero-sub">
                  {isRunning
                    ? "This is going to take a few minutes. Kindly request your patience."
                    : isCompleted
                    ? "Bulk order upload has been completed."
                    : "Waiting for bulk order upload information."}
                </div>
              </div>
              <div className="bld-hero-stats">
                <div className="bld-hero-stat bld-hs-green">
                  <i className="bi bi-check-circle-fill"></i>
                  <div>
                    <span>{successcount}</span> Successful
                  </div>
                </div>
                <div className="bld-hero-stat bld-hs-amber">
                  <i className="bi bi-hourglass-split"></i>
                  <div>
                    <span>{pendingCount}</span> Pending
                  </div>
                </div>
                <div className="bld-hero-stat bld-hs-blue">
                  <i className="bi bi-file-earmark-arrow-up"></i>
                  <div>
                    <span>{totalRecord}</span> Total
                  </div>
                </div>
              </div>
            </div>

            <div className="bld-progress-track">
              <div
                className="bld-progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <div className="bld-steps">
              <div className="bld-step bld-step-done">
                <i className="bi bi-check-lg"></i> Uploaded
              </div>
              <div
                className={`bld-step ${
                  uploadedRecord > 0 ? "bld-step-done" : ""
                }`}
              >
                {uploadedRecord > 0 ? (
                  <i className="bi bi-check-lg"></i>
                ) : (
                  <span className="bld-step-num">2</span>
                )}{" "}
                Validated
              </div>
              <div
                className={`bld-step ${
                  isRunning
                    ? "bld-step-active"
                    : isCompleted
                    ? "bld-step-done"
                    : ""
                }`}
              >
                {isRunning ? (
                  <span className="bld-step-dot"></span>
                ) : isCompleted ? (
                  <i className="bi bi-check-lg"></i>
                ) : (
                  <span className="bld-step-num">3</span>
                )}{" "}
                Processing
              </div>
              <div className={`bld-step ${isCompleted ? "bld-step-done" : ""}`}>
                {isCompleted ? (
                  <i className="bi bi-check-lg"></i>
                ) : (
                  <span className="bld-step-num">4</span>
                )}{" "}
                Complete
              </div>
            </div>
          </div>

          {isRunning && (
            <div className="bld-running">
              <div className="bld-running-pulse"></div>
              <div className="bld-running-body">
                <div className="bld-running-icon">
                  <i className="bi bi-activity"></i>
                </div>
                <div className="bld-running-text">
                  <div className="bld-running-title">Running in background</div>
                  <div className="bld-running-sub">
                    You can do other activities while we are creating your
                    orders.
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="bld-running-btn"
                onClick={handleRefreshButtonClick}
                title="Refresh status"
              >
                <i className="bi bi-arrow-clockwise"></i>
              </button>
            </div>
          )}

          <div className="bld-upload-card">
            <div className="bld-upload-hd">
              <div>
                <div className="bld-upload-id">
                  UPLOAD ID : {record_id || "-"}
                </div>
                <div className="bld-upload-meta">
                  {state?.create_date && (
                    <span>
                      <i className="bi bi-clock"></i> {state.create_date}
                    </span>
                  )}
                  <span
                    className={`bld-badge ${
                      isCompleted ? "bld-badge-done" : "bld-badge-running"
                    }`}
                  >
                    <i
                      className={`bi ${
                        isCompleted ? "bi-check-circle" : "bi-arrow-repeat"
                      }`}
                    ></i>{" "}
                    {isCompleted ? "Completed" : "Running"}
                  </span>
                </div>
              </div>
            </div>

            <div className="ol-status-nav bld-nav">
              <button
                type="button"
                className={`ol-snav ${activeTab === "success" ? "on" : ""}`}
                onClick={() => shipmentFilter(1)}
              >
                <i className="bi bi-check-circle"></i> Successful Uploads{" "}
                <span className="cnt">{successcount}</span>
              </button>
              <button
                type="button"
                className={`ol-snav ${activeTab === "failed" ? "on" : ""}`}
                onClick={() => shipmentFilter(2)}
              >
                <i className="bi bi-x-circle"></i> Failed Uploads{" "}
                <span className="cnt">{failedcount}</span>
              </button>
            </div>

            {activeTab === "success" ? (
              <div className="bld-tab-pane show" id="bldSuccess">
                <div className="bld-task-alert bld-task-success">
                  <div className="bld-task-icon">
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div className="bld-task-body">
                    <div className="bld-task-title">
                      {successcount}/{totalRecord} Order
                      {totalRecord === 1 ? "" : "s"} created successfully
                    </div>
                    <div className="bld-task-text">
                      You can now check and view the orders
                    </div>
                  </div>
                  <div className="bld-task-actions">
                    <button
                      type="button"
                      className="bld-btn bld-btn-outline"
                      onClick={successdownloadReport}
                      disabled={!successlog.length || downloading}
                    >
                      <i className="bi bi-download"></i>{" "}
                      {downloading ? "Preparing..." : "Report"}
                    </button>
                  </div>
                </div>

                <div className="bld-order-list">
                  {successlog.length ? (
                    successlog.map((sub, index) => (
                      <div
                        className="bld-order-row bld-order-ok"
                        key={`${sub?.order_id || "success"}-${index}`}
                      >
                        <div className="bld-order-icon">
                          <i className="bi bi-check-circle-fill"></i>
                        </div>
                        <div className="bld-order-body">
                          <div className="bld-order-id">
                            Order #{sub?.order_id || "-"}
                          </div>
                          <div className="bld-order-msg">
                            Order created successfully
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="py-3">
                      <h5>No Orders to show here</h5>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="bld-tab-pane show" id="bldFailed">
                <div className="bld-task-alert bld-task-danger">
                  <div className="bld-task-icon">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                  </div>
                  <div className="bld-task-body">
                    <div className="bld-task-title">
                      {failedcount} Order{failedcount === 1 ? "" : "s"} could
                      not be created
                    </div>
                    <div className="bld-task-text">
                      You will get remarks in the report
                    </div>
                  </div>
                  <div className="bld-task-actions">
                    <button
                      type="button"
                      className="bld-btn bld-btn-outline-red"
                      onClick={downloadReport}
                      disabled={!failedlog.length || downloading}
                    >
                      <i className="bi bi-download"></i>{" "}
                      {downloading ? "Preparing..." : "Report"}
                    </button>
                  </div>
                </div>

                <div className="bld-order-list">
                  {failedlog.length ? (
                    failedlog.map((sub, index) => (
                      <div
                        className="bld-order-row bld-order-fail"
                        key={`${sub?.order_id || "failed"}-${index}`}
                      >
                        <div className="bld-order-icon">
                          <i className="bi bi-exclamation-triangle-fill"></i>
                        </div>
                        <div className="bld-order-body">
                          <div className="bld-order-id">
                            Order #{sub?.order_id || "-"}
                          </div>
                          <div className="bld-order-msg">
                            Order could not be created
                          </div>
                          <div className="bld-order-err">
                            <i className="bi bi-info-circle"></i> Log Error:{" "}
                            <span>{sub?.reason || "Unknown error"}</span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="py-3">
                      <h5>No Orders to show here</h5>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Bulk_order_log_detail_new;
